// TODO: on remove element and clear localstore

import { Injectable } from '@angular/core';
import { sessionProfile, profileRoles } from '../../interfaces/sessionStorageModel';
import { SessionStorageService } from 'src/app/shared/services/session-storage/session-storage.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { Company } from '../../interfaces/company';
import { IdlePopUpComponent } from '../../components/idle-pop-up/idle-pop-up.component';
import { Modalconfig } from '../../constants';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommunicationService } from '../communication/communication.service';
@Injectable({
  providedIn: 'root'
})
export class IdleTimeOutService {
  loggedInProfile: sessionProfile;
  profileRolesEnum = profileRoles;
  maxIdleTime = 120;
  currentIdleTime = 0;
  ping = 60000;
  company: Company;
  idleInterval: any;
  isUserLoggedIn = true;
  bsModalRef: BsModalRef;
  constructor(
    private modalServices: BsModalService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private communicationService: CommunicationService
  ) {
    this.getLoggedInUserData();
  }

  getLoggedInUserData() {
    if (this.localStorageService.getLocalStogareByKey('isUserLoggedOut') === 'true') {
      this.openLoggedOutPopUp();
    } else {
      this.communicationService.getUserLoggedIn().subscribe(userLoggedInData => {
        this.loggedInProfile = this.sessionStorageService.getLoggedInProfileDetail();
        if (this.loggedInProfile) {
          clearInterval(this.idleInterval);
          this.assingIdleTime();
        }
      }
      );
    }
  }
  assingIdleTime() {
    if (this.loggedInProfile.role &&
      (this.loggedInProfile.role === this.profileRolesEnum.administrator
        || this.loggedInProfile.role === this.profileRolesEnum.playbookOwner
        || this.loggedInProfile.role === this.profileRolesEnum.user
        || this.loggedInProfile.role === this.profileRolesEnum.salesManager)
    ) {
      this.getIdleTime();
    } else {
      this.setUptimer();
    }
  }

  setUptimer() {
    this.idleInterval = setInterval(this.timerIncrement.bind(this), this.ping); // 1/2 minute

    document.onmousemove = this.resetTimer.bind(this);
    document.onkeypress = this.resetTimer.bind(this);
    document.onscroll = this.resetTimer.bind(this);
  }

  resetTimer() {
    if (this.isUserLoggedIn) {
      this.localStorageService.setLocalStogareByKey('userIdleTime', 0);
    }
  }
  timerIncrement() {
    if (!localStorage.getItem('userIdleTime')) {
      this.resetTimer();
      this.currentIdleTime = 0;
    }
    this.currentIdleTime = this.currentIdleTime + 1;
    this.localStorageService.setLocalStogareByKey('userIdleTime', this.currentIdleTime);
  }

  getIdleTime() {
    this.company = this.sessionStorageService.getCompanyData();
    if (this.company) {
      this.maxIdleTime = this.company.idleTimeOut;
    }
    this.setUptimer();
  }

  openLoggedOutPopUp() {
    this.isUserLoggedIn = false;
    clearInterval(this.idleInterval);
    this.localStorageService.setLocalStogareByKey('isUserLoggedOut', true);
    const initialState = {};
    this.bsModalRef = this.modalServices.show(IdlePopUpComponent,
      Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
  }
}
